module.exports = __webpack_public_path__ + "static/homepage-eab9b78e71e1282be4cf6db251f70781.jpg";